import Planner from "@/modules/planner/components/planner"

export default function PlannerPage() {
  return <Planner />
}
